import { render } from "./PackagesGroup.vue?vue&type=template&id=68f43e32&scoped=true"
import script from "./PackagesGroup.vue?vue&type=script&lang=js"
export * from "./PackagesGroup.vue?vue&type=script&lang=js"

import "./PackagesGroup.vue?vue&type=style&index=0&id=68f43e32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f43e32"]])

export default __exports__